import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  LIST_ITEM: `${cleanedFilename(__filename)}-list-item`,
  OFFICE_COLUMN: `${cleanedFilename(__filename)}-office-column`,
  ACTION: `${cleanedFilename(__filename)}-action`,
};
